<template>
  <div class="date-options">
    <div class="row">
      <!-- Year select -->
      <div class="col col-xs-12 col-sm-2">
        <UiSelect
          v-model="localYear"
          :options="years"
          placeholder="Год"
          :clearable="false"
          class="date-options_select"
        />
      </div>

      <!-- Month select -->
      <div class="col col-xs-12 col-sm-2">
        <UiSelect
          v-model="localMonth"
          :clearable="false"
          class="date-options_select"
          :reduce="(month) => month.value"
          label="text"
          :options="monthArray"
          placeholder="Месяц"
        />
      </div>

      <div class="col col-xs-12 col-sm-2">
        <AppSearchInput v-model="localDomain" class="date-options_input" />
      </div>

      <!-- Accept date button -->
      <div class="col col-xs-2">
        <UiButton class="button is-blue is-outlined" @click="acceptDate"> Показать </UiButton>
      </div>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/UiButton.vue'
import UiSelect from '@/components/UiSelect.vue'
import AppSearchInput from './AppSearchInput.vue'

import generateYearsArray from '@/utils/generateYearsArray'

import { CURRENT_YEAR, CURRENT_MONTH } from '@/config/date'

import syncQuery from '@/mixins/syncUrlQuery'
import monthArray from '@/mixins/monthArray'

export default {
  components: { UiSelect, UiButton, AppSearchInput },
  mixins: [syncQuery],
  data() {
    return {
      month: CURRENT_MONTH.toString(),
      localMonth: '',

      year: CURRENT_YEAR.toString(),
      localYear: '',

      domain: '',
      localDomain: '',

      monthArray: monthArray,
      years: generateYearsArray(CURRENT_YEAR, 2016, -1),
    }
  },
  mounted() {
    this.syncQuery(['year', 'month', 'domain'])

    this.syncComponentField('localMonth', 'month')
    this.syncComponentField('localYear', 'year')
    this.syncComponentField('localDomain', 'domain')
  },
  methods: {
    acceptDate() {
      const query = {
        month: this.localMonth,
        year: this.localYear,
        domain: this.localDomain,
      }

      this.updateQueryParams({ query })
    },
  },
}
</script>

<style lang="scss" scoped>
.date-options {
  &_input,
  &_select {
    margin: 0 0 rem(8px) 0;

    @include media_custom(656px) {
      margin: 0 rem(8px) 0 0;
    }
  }

  .col {
    padding: 0;
  }
}
</style>
